import React from 'react';
import '../myutils';
import CardLink from '../dashboard/CardLink';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    icon: { float: 'right', width: 64, height: 64, padding: 16, color: '#31708f' },
    image: { float: 'right', width: 72, height: 72, padding: 16, color: '#31708f' },
  });
  
const CardField = ({title, subtitle, link, titleData,subtitleData, icon, classes, record = {} }) => <Grid container spacing={3} >
<Grid item xs={12}>
    <CardLink title={title} link={link} titleData={record[titleData]} subtitle={subtitle} subtitleData={record[subtitleData]} icon={<img src={icon} className={classes.image} alt={''} />}
      variant={'display1'} alt={''}/>
</Grid>
</Grid>;

export default withStyles(styles)(CardField);
